import React from 'react';
import './App.css';
import Indiv from './modules/Indiv';
import { Layout } from './modules/Layout';

function App() {
  return (
    <div className="App">
      <Layout offset={{left: 1}}>
        <Indiv/>
      </Layout>
    </div>
  );
}

export default App;
